export default __webpack_public_path__ + "static/media/authentication.88c250f9.png";